exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".abrirpdf[_v-26fdc00e]:hover{text-decoration:none;color:#5b9bd1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-26fdc00e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/tables/table-t2/table.vue
// module id = 167
// module chunks = 0